// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"LoginPage_formContainer__7JtS7","formRow":"LoginPage_formRow__2uF7e","error":"LoginPage_error__2gWM_","registerLink":"LoginPage_registerLink__wSlr-"};